// Report kind in the download log. ResultReport is the legacy type from before reports were split by
// kind (it was always the final report); older rows keep it.
export type ReportType = "RequisitionForm" | "PreliminaryReport" | "FinalReport" | "SendOutReport" | "ResultReport";

// Which STARLIMS report to pull; all come from /reporting/retrieveattached by File_Type and are PDFs.
export type StarlimsReportType = "Final" | "Prelim" | "SendOut";

// A document that can be pulled for a sample: the requisition form or a STARLIMS report.
export type SampleDocumentType = "Requisition" | StarlimsReportType;

// Picker order; also the order documents appear in the merged PDF.
// `documentName` is how alerts refer to it ("ME123: Final Report").
// `logTypes` are the download-log types that count as already viewed for it.
export const SAMPLE_DOCUMENT_OPTIONS: { type: SampleDocumentType, label: string, documentName: string, logTypes: ReportType[] }[] = [
    { type: "Requisition", label: "Requisition", documentName: "Requisition Form", logTypes: ["RequisitionForm"] },
    { type: "Prelim", label: "Preliminary", documentName: "Preliminary Report", logTypes: ["PreliminaryReport"] },
    { type: "Final", label: "Final", documentName: "Final Report", logTypes: ["FinalReport", "ResultReport"] },
    { type: "SendOut", label: "Send Out", documentName: "Send Out Report", logTypes: ["SendOutReport"] },
];

// Max samples x document types per download; the backend enforces the same limit.
export const MAX_DOCUMENTS_PER_DOWNLOAD = 100;

export interface ReportDownloadSummary {
    ReqNum: string
    ReportType: ReportType
    DownloadCount: number
    LastDownloadedDate: string
    // Name (or email) of whoever made the most recent download
    LastDownloadedBy?: string | null
}

export interface ReportDownloadHistory {
    ID: number
    ReqNum: string
    ReportType: ReportType
    DownloadMethod: "Single" | "Bulk"
    UserEmail: string
    UserName: string
    DownloadedDate: string
}

export const REPORT_TYPE_LABELS: { [key in ReportType]: string } = {
    RequisitionForm: "Requisition Form",
    PreliminaryReport: "Preliminary Report",
    FinalReport: "Final Report",
    SendOutReport: "Send Out Report",
    ResultReport: "Result Report",
};
